import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-pos',
  templateUrl: './add-pos.component.html',
  styleUrls: ['./add-pos.component.scss']
})
export class AddPosComponent {
  public tableName: string = '';

  constructor(
    private dialogRef: MatDialogRef<AddPosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Use Inject to pass dialog data if needed
  ) {
    this.tableName = data?.name || '';
  }

  onSave(): void {
    // Pass the entered name back to the parent on Save
    this.dialogRef.close(this.tableName);
  }

  onCancel(): void {
    // Close the dialog without saving
    this.dialogRef.close();
  }
}
